import { Grid } from "@mui/material";
import React, { Component } from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#0957ED",
        padding: "10px",
        borderRadius: "40px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#0957ED",
        padding: "10px",
        borderRadius: "40px",
      }}
      onClick={onClick}
    />
  );
}

export default class MultipleItems extends Component {
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div className="Slider_main">
        <Grid
          container
          alignItems="center"
          sx={{
            justifyContent: {
              xs: "center",
              sm: "center",
              md: "space-around",
              lg: "space-between",
            },
          }}
        >
          <Grid item lg={4}>
            <h1 className="activity_header">Discover all Creators</h1>
          </Grid>
          <Grid item xs={8} lg={6}>
            <div className="search_form">
              <input
                type="text"
                placeholder="search"
                className="activity_input"
              />
              <button className="search_btn">
                <img src="./Assets/Vector.png" alt="" />
              </button>
            </div>
          </Grid>
        </Grid>
        <div className="seprator"></div>
        <Slider {...settings}>
          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_1.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_1.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">345</h2>
                <span className="s_span">Collection</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">17,005</h2>
                <span className="s_span">Views</span>
              </div>
            </div>
          </div>
          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_2.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_2.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
            </div>
          </div>

          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_3.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_3.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
            </div>
          </div>

          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_1.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_1.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">345</h2>
                <span className="s_span">Collection</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">17,005</h2>
                <span className="s_span">Views</span>
              </div>
            </div>
          </div>
          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_2.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_2.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
            </div>
          </div>

          <div className="slider_card">
            <div>
              <img
                src="./Assets/pop_s_3.png"
                className="margin_remove"
                alt=""
              />
              <img src="./Assets/pop_i_3.png" className="img_ani" alt="" />
            </div>
            <div className="whole_slider">
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
              <div className="slider_bg">
                <h2 className="s_upper">191 ETH</h2>
                <span className="s_span">Sold</span>
              </div>
            </div>
            <div className="seprator"></div>
          </div>
        </Slider>
      </div>
    );
  }
}
